import { createContext, useContext } from 'react';

export const TabContainerContext = createContext({
  activeTab: '0',
  setActiveTab: (tabIndex: string) => {},
});
export const useTabContainer = () => {
  const tabContext = useContext(TabContainerContext);
  return tabContext;
};
